<template>
  <pl-dialog
    @close="close"
    :title="message"
    :size="'relative'"
    :disableOutsideClick="true"
  >
    <slot></slot>
    <body
      v-if="typeConfirm"
      class="px-7 pt-7 pb-4 flex-grow overflow-y-auto bg-white"
      style="min-height: 95px; background-color: white"
    >
      <pl-input
        v-if="!isSaving"
        v-model="confirmMessage"
        @keyup.native.enter="confirm"
        :errorMessage="errorMessage"
        :labelText="labelText"
        style="padding: 0 28px"
      />
      <div v-else class="flex justify-center">
        <pl-spinner />
      </div>
    </body>
    <footer
      class="w-full center text-sm py-4 bg-white rounded-b inline-flex justify-center my-3"
      :class="!typeConfirm ? 'items-center' : 'mt-0'"
      style="min-height: 52px"
    >
      <button
        @click="close"
        class="bg-gray-100 hover:bg-gray-200 py-2 px-7 font-semibold text-gray-600 rounded mr-2"
      >
        Cancel
      </button>
      <button
        @click="confirm"
        class="py-2 px-6 font-semibold rounded text-white"
        :class="confirmColor"
      >
        {{ confirmText }}
      </button>
    </footer>
  </pl-dialog>
</template>

<script>
  import { EventBus } from 'utils/event-bus';
  export default {
    data() {
      return {
        confirmMessage: '',
        errorMessage: '',
        labelText: 'Please type in "confirm" to continue',
      };
    },
    props: {
      message: {
        type: String,
        default: 'Are you sure?',
      },
      isSaving: {
        type: Boolean,
        default: false,
      },
      typeConfirm: {
        type: Boolean,
        default: true,
      },
      confirmColor: {
        type: String,
        default: 'bg-primary',
      },
      confirmText: {
        type: String,
        default: 'CONFIRM',
      },
    },
    methods: {
      confirm() {
        if (this.confirmMessage === 'confirm' || !this.typeConfirm) {
          this.errorMessage = '';
          this.confirmMessage = '';
          this.$emit('confirm');
          this.close();
        } else {
          this.errorMessage = 'Incorrect spelling. Please try again';
          const toast = {
            type: 'Error',
            message: 'Please type in "confirm" to continue!',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
        }
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// plDialogConfirm.vue?e3127668